<template>
  <v-app id="jns" toolbar footer>
    <JNSMenu v-if="displayMenu" />

    <router-view />
    <modal-helpers />
    <form-alert-full-block v-if="displayFullBlockAlert" />
  </v-app>
</template>

<script lang="js">
import axios from "axios";
import JNSMenu from "@/components/JNSMenu";

const urls = ["localhost", "stage.portal.jnsseguros.com.br"];

const dontShowMenu = [
  "Login",
  "Termos de Serviço",
];

export default {
  name: "app",
  components: {
    JNSMenu,
  },

  data() {
    return {
      intervaloHorarioAtendimento: false,
      alertText: {},
    };
  },

  mounted() {
    this.init();
  },

  destroyed() {
    clearInterval(this.intervaloHorarioAtendimento);
  },

  computed: {
    displayMenu() {
      return !dontShowMenu.includes(this.$route.name);
    },

    displayFullBlockAlert() {
      const { name } = this.$route;
      const isLogin = name == 'Login';
      return (isLogin && this.desabilitaLogin) ||
        (!isLogin && this.mostraMensagemBloqueio);
    }
  },

  methods: {
    async init() {
      if (urls.filter(this.ativaHorarioAtendimento).length == 0) {
        this.horarioAtendimento();
        this.intervaloHorarioAtendimento = setInterval(
          this.horarioAtendimento,
          15000
        );
      }
    },

    ativaHorarioAtendimento(url) {
      return window.location.hostname == url;
    },

    horarioAtendimento() {
      var now = new Date();

      var milisegundosDataInicial =
        now -
        new Date(now.getFullYear(), now.getMonth(), now.getDate(), 7, 15, 0, 0);

      var milisegundosDataFinal =
        new Date(
          now.getFullYear(),
          now.getMonth(),
          now.getDate(),
          23,
          55,
          0,
          0
        ) - now;

      if (
        !this.mostraMensagemBloqueio &&
        milisegundosDataFinal > 0 &&
        milisegundosDataFinal <= 300000
      ) {
        this.mostraMensagemBloqueio = true;
      } else if (milisegundosDataFinal <= 0 || milisegundosDataInicial <= 0) {
        this.mostraMensagemBloqueio = true;
        this.$set(this, "desabilitaLogin", true);
        this.desabilitaLogin = true;

        if (this.$route.name != "Login") {
          localStorage.clear();
          delete axios.defaults.headers.common["Authorization"];
          this.$router.push({ name: "Login" });
        }
      } else if (
        milisegundosDataInicial > 0 &&
        milisegundosDataFinal > 300000
      ) {
        this.mostraMensagemBloqueio = false;
        this.desabilitaLogin = false;
      }
      this.$forceUpdate();
    },
  },
};
</script>

<style lang="scss">
@import "assets/main.scss";
.lowercase {
  text-transform: lowercase;
  input {
    text-transform: lowercase;
  }
}
.uppercase {
  text-transform: uppercase;
}
main .container {
  margin-left: 0;
}
.no-padding {
  padding: 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue